export const safeJsonParse = (value, fallback) => {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const set = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};
export const get = (key) => {
  const raw = typeof window !== "undefined" ? localStorage.getItem(key) : null;
  if (raw === null) return null;
  return safeJsonParse(raw, null);
};

export const getMerchant = () => {
  const merchant = get("merchant");
  return merchant || { _id: null, name: null };
};

export const setMerchant = (merchant) => {
  set("merchant", merchant);
};
